import { supabase } from "@/shared/lib/supabase";

export function getAssistantFunctionUrl(path: string): string {
  const normalizedPath = path.startsWith("/") ? path : `/${path}`;
  return `${import.meta.env.VITE_SUPABASE_URL}/functions/v1/assistant${normalizedPath}`;
}

export async function getAccessToken(): Promise<string> {
  const {
    data: { session },
  } = await supabase.auth.getSession();

  if (!session) {
    throw new Error("No session");
  }

  return session.access_token;
}

export async function readErrorMessage(response: Response): Promise<string> {
  try {
    const body = (await response.json()) as {
      message?: string;
      error?: string;
    };
    return body.message || body.error || response.statusText;
  } catch {
    return response.statusText;
  }
}

export async function assistantFetchJson<T>(
  path: string,
  accessToken: string,
  init: RequestInit = {},
): Promise<T> {
  const headers = new Headers({
    Authorization: `Bearer ${accessToken}`,
    "Content-Type": "application/json",
  });
  new Headers(init.headers).forEach((value, key) => {
    headers.set(key, value);
  });

  const response = await fetch(getAssistantFunctionUrl(path), {
    ...init,
    headers,
  });

  if (!response.ok) {
    throw new Error(await readErrorMessage(response));
  }

  return (await response.json()) as T;
}
